import { memo } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { PageContainer } from '@/components/templates/PageContainer';

const TOOLBAR_BUTTON_COUNT = 6;
const TOOLBAR_TRAILING_BUTTON_COUNT = 2;

/**
 * Skeleton for the NoteEditor page — matches the 3-zone "Digital Paper" layout
 * (toolbar → paper surface → footer) for CLS=0 transitions.
 */
export const NoteEditorPageSkeleton = memo(() => {
  return (
    <PageContainer className="h-[calc(100vh-96px-5vh)] overflow-hidden pb-0">
      <div className="h-full flex flex-col">
        {/* TOP: Toolbar skeleton */}
        <div className="flex gap-2 items-center px-2 py-1.5 border-b border-border">
          {Array.from({ length: TOOLBAR_BUTTON_COUNT }, (_, i) => (
            <Skeleton key={`btn-${i}`} className="h-8 w-8 rounded-md" />
          ))}
          <Skeleton className="h-8 w-px rounded-none" />
          {Array.from({ length: TOOLBAR_TRAILING_BUTTON_COUNT }, (_, i) => (
            <Skeleton key={`trail-${i}`} className="h-8 w-8 rounded-md" />
          ))}
        </div>

        {/* MIDDLE: Paper surface skeleton */}
        <div className="flex-1 flex justify-center py-4">
          <Skeleton className="w-full max-w-[816px] h-full rounded-lg" />
        </div>

        {/* BOTTOM: Footer skeleton */}
        <Skeleton className="h-11 w-full rounded-md" />
      </div>
    </PageContainer>
  );
});

NoteEditorPageSkeleton.displayName = 'NoteEditorPageSkeleton';
